import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FAQ() {
  const { t } = useTranslation("blog-kozijn-schilderen");
  const items = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="pt-4 md:pt-6">
      <h2 className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-5 md:mb-6">
        {t("faq.h2")}
      </h2>
      <div className="flex flex-col gap-3 md:gap-4">
        {items.map((item, idx) => {
          const isOpen = openIdx === idx;
          return (
            <div
              key={idx}
              className={`border rounded-xl overflow-hidden transition-colors ${
                isOpen ? "border-brand-yellow bg-[#FFF9E0]/30" : "border-brand-border bg-white"
              }`}
            >
              <button
                onClick={() => setOpenIdx(isOpen ? null : idx)}
                className="w-full flex items-start justify-between gap-3 p-4 md:p-5 text-left"
                aria-expanded={isOpen}
              >
                <span className="font-geist font-semibold text-sm md:text-base text-brand-text leading-snug">
                  {item.q}
                </span>
                <span className="flex-shrink-0 w-6 h-6 rounded-full border border-brand-text/20 flex items-center justify-center mt-0.5">
                  <i
                    className={`ri-${isOpen ? "subtract" : "add"}-line w-4 h-4 flex items-center justify-center text-sm text-brand-text/60`}
                  ></i>
                </span>
              </button>
              {isOpen && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}